export const INVITE_STATUS = {
    PENDING: 'Pending',
    ACTIVE: 'Active',
    REJECTED: 'Rejected'
}

export const MAX_TABLE_HEADER_LENGTH = 35;
export const MINIMUM_PASSWORD_LENGTH = 8;  